































































































































































import { Component, Vue } from "vue-property-decorator";
import "./navbar.css";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import BaseApi from "@/core/HttpResources/BaseApi";
import Notificacion from "@/models/notificacion/notificacion.model";
import * as signalR from "@aspnet/signalr";
import UsuarioService from "@/services/usuario.service";
import hubService from "@/services/hub.service";
import { AppNotificationType } from "@/enums/Codes";
import Helpers from "@/helpers/helper";
import { AppNotificationReceiver } from '@/models/appNotification/appNotificationReceiver.model';
import { getSessionToken } from "@/helpers/sessionStorage";

@Component({})
export default class NavbarComponent extends Vue {
  notifications: Array<Notificacion> = [];
  usrService = new UsuarioService();
  loadingChangePasswordSave = false;
  showChangePassword = false;
  getAppNotificationsTotal = 0;
  appNotifications: Array<AppNotificationReceiver> = [];
  changePasswordModel: any = {
    actualPassword: "",
    newPassword: "",
    userID: 0,
  };
  headers = {
    Authorization: `Bearer ${getSessionToken()}`,
  };
  appNotificationRepo = new BaseRepository<AppNotificationReceiver>(
    "AppNotificationReceiver"
  );
  showNotifications = false;
  private appNotificationMarkedAsReadHandler = (
    payload: AppNotificationReceiver
  ) => {
    this.showNotifications = false;
    this.getAppNotifications();
  };
  private appNotificationReceivedHandler = (userIDs: number[], refId: number) => {
    if (userIDs && userIDs.some((x) => x === this.user.id))
      this.getAppNotifications();
  };
  mounted() {
    Helpers.EventBus.$on(
      "APP_NOTIFICATION_MARKED_AS_READ",
      this.appNotificationMarkedAsReadHandler
    );
  }
  beforeDestroy() {
    Helpers.EventBus.$off(
      "APP_NOTIFICATION_MARKED_AS_READ",
      this.appNotificationMarkedAsReadHandler
    );
    hubService.offAppNotificaction(this.appNotificationReceivedHandler);
  }
  async getAppNotifications() {
    if (!this.isLoggedIn || !this.user || !this.user.id) {
      this.getAppNotificationsTotal = 0;
      this.appNotifications = [];
      return;
    }
    try {
      let resourse = `${this.user.id}/pendientes`;
      var result = (await this.appNotificationRepo.client.getAsync(
        resourse
      )) as any;
      this.getAppNotificationsTotal = result.total;
      this.appNotifications = result.records;
    } catch (error) {
      this.getAppNotificationsTotal = 0;
      this.appNotifications = [];
    }
  }
  appNotificationDetail(item: AppNotificationReceiver) {
    this.markAsReadAN(item);
    switch (item.type) {
      case AppNotificationType.TRAMITE_COMPLETADO:
        this.$router.push(`/resumen-solicitud/${item.refEntityDetailValue}`);
        break;
      case AppNotificationType.TRAMITE_RECHAZADO:
        this.$router.push(`/resumen-solicitud/${item.refEntityDetailValue}`);
        break;
      case AppNotificationType.PSONLINE_TRAMITE_COMENTADO:
        this.$router.push(`/resumen-solicitud/${item.refEntityDetailValue}`);
        break;
      default:
        break;
    }
  }
  async markAsReadAN(item: AppNotificationReceiver) {
    if (item) {
      if (item.read === false) {
        let markedAsRead = false;
        try {
          let id = item.id as number;
          await this.appNotificationRepo.client.putAsync(
            "MarkAsRead",
            id,
            item
          );
          markedAsRead = true;
        } catch (error) {
          this.$buefy.toast.open({
            message: "No se pudo marcar la notificación como leída.",
            type: "is-danger"
          });
        } finally {
          if (markedAsRead) {
            this.getAppNotifications();
          }
        }
      }
    }
  }
  getHtsColor(value: boolean) {
    return !value ? "hsl(217, 71%, 53%)" : "";
  }
  getANColor(item: AppNotificationReceiver) {
    if (!item.read) return "link";
    switch (item.type) {
      case AppNotificationType.SOLICITUD_USUARIO_ACEPTADA:
        return "success";
      case AppNotificationType.TRAMITE_COMPLETADO:
        return "success";
      case AppNotificationType.SOLICITUD_USUARIO_CREADA:
        return "grey";
      case AppNotificationType.PSINFO_ACTIVIDAD_CREADA:
        return "grey";
      case AppNotificationType.PSONLINE_TRAMITE_COMENTADO:
        return "grey";
      case AppNotificationType.SOLICITUD_USUARIO_RECHAZADA:
        return "danger";
      case AppNotificationType.TRAMITE_RECHAZADO:
        return "danger";
      default:
        break;
    }
  }
  get isLoggedIn() {
    return this.$store.getters.isLoggedIn;
  }
  get user() {
    return this.$store.state.user;
  }
  get isMobile() {
    return this.$store.state.isMobile;
  }
  get isQuickReference() {
    return !!this.$route.params.cedula;
  }
  cancelarChangePass() {
    this.showChangePassword = false;
    this.changePasswordModel = {
      actualPassword: "",
      newPassword: "",
      userID: 0,
    };
  }
  changePassword() {
    var userID = this.$store.state.user.id;
    this.changePasswordModel.userID = userID;
    this.loadingChangePasswordSave = true;
    this.usrService
      .updateUserPassword(this.changePasswordModel)
      .then((usuario) => {
        this.$buefy.toast.open({
          message: "Los cambios se han aplicado correctamente!",
          type: "is-success",
        });
        this.cancelarChangePass();
      })
      .catch((ex) => {
        let exepction = ex.response.data[0];
        if (exepction && exepction.code == "PasswordMismatch") {
          this.$buefy.toast.open({
            message: "Contraseña incorrecta!",
            type: "is-danger",
          });
        }
      })
      .finally(() => {
        this.loadingChangePasswordSave = false;
      });
  }
  registerSignalRInterceptor() {
    if (!this.isLoggedIn || !this.user || !this.user.id) {
      return;
    }

    hubService.offAppNotificaction(this.appNotificationReceivedHandler);
    hubService.onAppNotificaction(this.appNotificationReceivedHandler);
    // hubService.onUserMessageReceived((userIDs: number[]) =>
    //   this.notificationReceived(userIDs)
    // );
  }
  notificationReceived(userIDs: number[]) {
    for (let i = 0; i < userIDs.length; i++) {
      const userID = userIDs[i];
      if (this.user.id == userID) {
        this.getNotifications();
      }
    }
  }
  searchMessage(id: number) {
    if (id) this.$router.push({ path: `/mensajeria/${id}` });
  }
  getNotifications() {
    if (this.isLoggedIn) {
      var baseApi = new BaseApi("Notificacion/LastNotifications");
      new Promise<Array<Notificacion>>((resolve, reject) =>
        baseApi.request(
          "GET",
          String(),
          null,
          {},
          (response) => resolve(response.data),
          reject,
          () => {}
        )
      ).then((notifications) => {
        this.notifications = notifications;
      });
    }
  }
  logout() {
    this.$buefy.dialog.confirm({
      title: "Cerrando sesión",
      message: "¿Desea cerrar sesión?",
      confirmText: "Cerrar sesión",
      type: "is-primary",
      hasIcon: true,
      onConfirm: () => {
        this.$store.dispatch("logout").then(() => {
          this.$router.push("/login");
        });
      },
    });
  }

  created() {
    if (this.isLoggedIn && this.user && this.user.id) {
      // this.getNotifications();
      this.getAppNotifications();
      this.registerSignalRInterceptor();
    }
  }
  sendToHome() {
    this.$router.push(`/`);
  }
  sendToLogin() {
    this.$buefy.dialog.confirm({
      title: "Confirmación",
      message: "¿Desea terminar la consulta?",
      confirmText: "Adelante!",
      cancelText: "Cancelar",
      type: "is-dark",
      size: "is-medium",
      hasIcon: true,
      onConfirm: () => {
        // Consulta rápida temporalmente desactivada.
        // if (localStorage.getItem("consultaRapida"))
        //   localStorage.removeItem("consultaRapida");
        this.$router.push(`/login`);
      },
    });
  }
  goToAppNotifications() {
    this.showNotifications = true;
  }
}
